export default "__VITE_ASSET__6ooxgBYU__"